module.exports = __webpack_public_path__ + "img/careers-recruiting-process-1.png?2870318208b742f301cf1dd9193583d8";